<template>
  <bd-config-provider :locale="locale">
    <div style="height: 100%">
      <router-view></router-view>
    </div>
  </bd-config-provider>
</template>

<script>
import { defineComponent } from 'vue'

import 'dayjs/locale/zh-cn'
import zhCn from '@bilibili-business/bili-design/es/locale/lang/zh-cn'

export default defineComponent({
  name: 'app',
  errorCaptured(err, vm, info) {
    const ERROR_WHITE_LIST = ['Unable to preload CSS']
    const reg = new RegExp(ERROR_WHITE_LIST.join('|'))
    if (err && err.message && reg.test(err.message)) {
      return false
    }
    return true
  },
  setup() {
    return {
      locale: zhCn
    }
  }
})
</script>
